export default class ImageCapture {
  private vid: TypeMePlease;
  private imageQuality: TypeMePlease;
  private width: TypeMePlease;
  private height: TypeMePlease;
  private cameraWidth: TypeMePlease;
  private cameraHeight: TypeMePlease;

  constructor(video, imageQuality, width, height) {
    this.initCamera = this.initCamera.bind(this);
    this.stopCamera = this.stopCamera.bind(this);
    this.vid = video;
    this.imageQuality = imageQuality;
    this.width = width;
    this.height = height;
    this.cameraWidth = null;
    this.cameraHeight = null;
  }

  takePicture() {
    const canvas = document.createElement('canvas');
    canvas.width = this.cameraWidth;
    canvas.height = this.cameraHeight;
    const context = canvas.getContext('2d');
    context.drawImage(this.vid, 0, 0, this.cameraWidth, this.cameraHeight);
    this.stopCamera();
    return canvas.toDataURL('image/jpeg');
  }

  stopCamera() {
    if (this.vid && this.vid.srcObject) {
      this.vid.srcObject.getVideoTracks().forEach((track) => track.stop());
    } else if (this.vid) {
      //wait for Promise to resolve to stop camera if component unmounted early
      let maxRetry = 3;
      const checkCamera = setInterval(() => {
        if (this.vid.srcObject) {
          this.vid.srcObject.getVideoTracks().forEach((track) => track.stop());
          clearInterval(checkCamera);
        }
        maxRetry--;
        if (maxRetry === 0) {
          clearInterval(checkCamera);
        }
      }, 250);
    }
  }

  static async getDevices() {
    const cameras = [];
    const deviceInfos = await navigator.mediaDevices.enumerateDevices();
    for (let i = 0; i !== deviceInfos.length; i++) {
      const deviceInfo = deviceInfos[i];
      if (deviceInfo.kind === 'videoinput') {
        cameras.push({
          deviceId: deviceInfo.deviceId,
          friendlyName: deviceInfo.label || `camera ${cameras.length + 1}`
        });
      }
    }
    return cameras;
  }

  async changeDevice(deviceId) {
    this.stopCamera();
    const constraints = { deviceId: { exact: deviceId } };
    const stream = await navigator.mediaDevices.getUserMedia({ video: constraints, audio: false });
    this.vid.srcObject = stream;
  }

  async getVideoDimensions() {
    const dims = await new Promise<{ cameraWidth: number; cameraHeight: number }>((resolve) => {
      this.vid.onloadedmetadata = function () {
        const cameraWidth = this.videoWidth;
        const cameraHeight = this.videoHeight;
        resolve({ cameraWidth, cameraHeight });
      };
    }).catch((err) => {
      throw err;
    });

    return dims;
  }

  async initCamera() {
    try {
      const cameras = await ImageCapture.getDevices();
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          width: { min: 640, ideal: this.width, max: 1280 },
          height: { min: 480, ideal: this.height, max: 720 },
          advanced: [{ width: 1920, height: 1280 }, { aspectRatio: 4 / 3 }]
        },
        audio: false
      });
      this.vid.srcObject = stream;
      this.vid.muted = true;
      const { cameraWidth, cameraHeight } = await this.getVideoDimensions();
      this.cameraWidth = cameraWidth;
      this.cameraHeight = cameraHeight;

      return {
        cameras,
        cameraHeight,
        cameraWidth,
        stream,
        error: null
      };
    } catch (err) {
      return {
        cameras: null,
        stream: null,
        error: err.messasge
      };
    }
  }
}
